import React, { useState } from "react";
import { Box, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div";
import WelcomeScreenTab from "./WelcomeScreenTab";

/**
 * Správa kioskov – sekcia v časti "Self Ordering Kiosk" (pod Väzbami).
 * Dostupná pre každého zákazníka, nezávislá na iných nastaveniach.
 * Obsahuje záložky; prvá je "Úvodná obrazovka" (obsah sa doplní neskôr).
 */
const KioskManagement = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("welcome-screen");

  return (
    <Div sx={{ px: 1 }}>
      <Typography variant="h2" mb={3}>
        {t("pages.kioskManagement.title", { defaultValue: "Správa kioskov" })}
      </Typography>

      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={(_e, value) => setActiveTab(value)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={t("pages.kioskManagement.tabs.welcomeScreen", {
                defaultValue: "Úvodná obrazovka",
              })}
              value="welcome-screen"
            />
          </TabList>
        </Box>

        <TabPanel value="welcome-screen" sx={{ px: 0 }}>
          <WelcomeScreenTab />
        </TabPanel>
      </TabContext>
    </Div>
  );
};

export default KioskManagement;
